import {
  isTruthy,
  openErrorNotification,
} from "../../../../../helpers/methods";

export const initialState = (inputResponse: any, isEdit = false) => {
  return {
    total_leave: { value: inputResponse.total_leave ?? "", error: "" },
    earned_leave: { value: inputResponse.earned_leave ?? "", error: "" },
    sick_leave: { value: inputResponse.sick_leave ?? "", error: "" },
    casual_leave: { value: inputResponse.casual_leave ?? "", error: "" },
    id: { value: inputResponse._id ?? "", error: "" },
  };
};

export const handleValidation = (rawInput: any) => {
  const someOfLeave =
    parseFloat(rawInput.earned_leave.value) +
    parseFloat(rawInput.sick_leave.value) +
    parseFloat(rawInput.casual_leave.value);
  if (rawInput.total_leave.value < someOfLeave) {
    rawInput.casual_leave.error = "Should be less than or equal to total leave";
    rawInput.sick_leave.error = "Should be less than or equal to total leave";
    rawInput.earned_leave.error = "Should be less than or equal to total leave";
  }

  if (rawInput.total_leave.value == "") {
    rawInput.total_leave.error = "Please enter total leave";
  }
  if (rawInput.earned_leave.value.length == "") {
    rawInput.earned_leave.error = "Please enter earned leave";
  }
  if (rawInput.sick_leave.value == "") {
    rawInput.sick_leave.error = "Please enter sick leave";
  }
  if (rawInput.casual_leave.value.length == "") {
    rawInput.casual_leave.error = "Please enter casual leave";
  }
  return rawInput;
};

export const getFinalBodyStructure = (inputBody: any) => {
  let finalBody = {};
  for (const key in inputBody) {
    finalBody = { ...finalBody, [key]: inputBody[key].value };
  }
  const newObj: any = { ...finalBody };

  // newObj.organizationId = userId;

  // ["updatedAt", "__v", "createdAt"].forEach((key: any) => delete newObj[key]);

  return newObj;
};

export const validateInput = (name: any, value: any) => {
  if (value !== "") {
    if (!/^[0-9.]+$/.test(value)) {
      return false;
    }
  }
  return true;
};
